import { Roles } from "../../constants/roles";

import { FormBase } from "../../util/form-base-form";

export class UserFollowForm extends FormBase {
    public getContainers(root: ParentNode = document): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.USER_FOLLOW}"][data-target-user-id]`, HTMLElement);
    }

    public getProfilePanelsRoot(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, ".user-profile-panels[data-user-id]", HTMLElement);
    }

    public getSourceSlide(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".user-card-slide", HTMLElement);
    }

    public getContainer(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW}"][data-target-user-id]`, HTMLElement);
    }

    public getToggleButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.FOLLOW_TOGGLE_BTN}"]`, HTMLButtonElement);
    }

    public getToggleLabel(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.FOLLOW_TOGGLE_LABEL}"]`, HTMLElement);
    }

    public getFollowersCount(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.USER_PROFILE_TAB_COUNT}"][data-tab-count="followers"]`,
            HTMLElement,
        );
    }

    public getFollowersList(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.FOLLOWERS_LIST}"]`, HTMLElement);
    }

    public getFollowingsCount(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.USER_PROFILE_TAB_COUNT}"][data-tab-count="followings"]`,
            HTMLElement,
        );
    }

    public getFollowingsList(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.FOLLOWINGS_LIST}"]`, HTMLElement);
    }

    public getFollowingCard(root: ParentNode, userId: number): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.USER_PROFILE_FOLLOWING_CARD}"][data-following-user-id="${String(userId)}"]`,
            HTMLElement,
        );
    }

    public getAnyFollowingCard(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_PROFILE_FOLLOWING_CARD}"]`, HTMLElement);
    }

    public getFollowContainer(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW}"][data-target-user-id]`, HTMLElement);
    }

    public getNoFollowingMessage(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-translate="no_following"]`, HTMLElement);
    }

    public getFollowersEmpty(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_FOLLOWERS_EMPTY}"]`, HTMLElement);
    }

    public getFollowerItems(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.USER_FOLLOW_ITEM}"][data-user-id]`, HTMLElement);
    }

    public getFollowerItem(root: ParentNode, userId: number): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.USER_FOLLOW_ITEM}"][data-user-id="${String(userId)}"]`,
            HTMLElement,
        );
    }

    public getFollowerItemByUserData(root: ParentNode, userId: number): HTMLElement | null {
        return this.queryElement(root, `[data-user-id="${String(userId)}"]`, HTMLElement);
    }

    public getFollowerAvatar(root: ParentNode): HTMLImageElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_AVATAR}"]`, HTMLImageElement);
    }

    public getFollowerName(root: ParentNode): HTMLAnchorElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_NAME}"]`, HTMLAnchorElement);
    }

    public getFollowerPostsCount(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_POSTS_COUNT}"]`, HTMLElement);
    }

    public getFollowerPostsValue(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_POSTS_VALUE}"]`, HTMLElement);
    }

    public getFollowerFollowersCount(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_FOLLOWERS_COUNT}"]`, HTMLElement);
    }

    public getFollowerFollowersValue(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_FOLLOWERS_VALUE}"]`, HTMLElement);
    }

    public getFollowerAttrs(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_ATTRS}"]`, HTMLElement);
    }

    public getFollowerSkinType(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_SKIN_TYPE}"]`, HTMLElement);
    }

    public getFollowerSkinTypeValue(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_SKIN_TYPE_VALUE}"]`, HTMLElement);
    }

    public getFollowerSkinConcerns(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_SKIN_CONCERNS}"]`, HTMLElement);
    }

    public getFollowerSkinConcernsValue(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USER_FOLLOW_SKIN_CONCERNS_VALUE}"]`, HTMLElement);
    }
}

export const userFollowForm = new UserFollowForm();
